import type { Novidade } from './tipos';

/** Ficha 2026-11-03: modos Maré, Gelo e Malgo, Noite, modelo próprio e assinatura oficial. */
export const novidadeModosDeCor: Novidade = {
  id: '2026-11-03-modos-de-cor',
  publicada_em: '2026-11-03',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Sistema de cara nova',
      resumo: 'O MalgoOS agora vem na Maré, com as cores e a assinatura da marca. Gelo e o visual anterior seguem disponíveis.',
      passos: [
        'Para escolher só para você, abra Minha conta > Aparência. O tema escuro de Maré e Gelo é a Noite.',
        'Para o workspace inteiro, use Admin > Configurações > Aparência, no cartão Estilo de interface do workspace.',
        'No cartão Modelos próprios, parta de um modo, ajuste as cores e aplique. Só salva quando o contraste passa.',
      ],
    },
    en: {
      titulo: 'A new look for the system',
      resumo: 'MalgoOS now comes in Tide, with the brand colors and signature. Ice and the previous look are still available.',
      passos: [
        'To choose just for you, open My account > Appearance. The dark theme of Tide and Ice is Night.',
        'For the whole workspace, use Admin > Settings > Appearance, in the Workspace interface style card.',
        'In the Custom models card, start from a mode, adjust the colors and apply. It only saves when contrast passes.',
      ],
    },
    es: {
      titulo: 'El sistema con cara nueva',
      resumo: 'MalgoOS ahora viene en Marea, con los colores y la firma de la marca. Hielo y el aspecto anterior siguen disponibles.',
      passos: [
        'Para elegir solo para ti, abre Mi cuenta > Apariencia. El tema oscuro de Marea e Hielo es Noche.',
        'Para todo el workspace, usa Admin > Configuraciones > Apariencia, en la tarjeta Estilo de interfaz del workspace.',
        'En la tarjeta Modelos propios, parte de un modo, ajusta los colores y aplica. Solo guarda cuando el contraste pasa.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
  rota: '/conta/aparencia',
};
